import { SET_BUDGET_ITEMS } from "../../../constants";

export const setBudgetItems = (items: any = []) => ({
  type: SET_BUDGET_ITEMS,
  payload: items,
});
